import { render, staticRenderFns } from "./CSalesComparison.vue?vue&type=template&id=02547c89&scoped=true"
import script from "./CSalesComparison.vue?vue&type=script&lang=ts"
export * from "./CSalesComparison.vue?vue&type=script&lang=ts"
import style0 from "./CSalesComparison.vue?vue&type=style&index=0&id=02547c89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02547c89",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VRow,VSimpleTable})
